import React, { useEffect } from 'react';
import NikeAIPanelWrapper from '../NikeAIPanelWrapper';
import { initializeNikeAI } from '../../utils/nikeAIController';

/**
 * Nike AI Loader
 * Initializes the Nike AI controller and renders the panel wrapper.
 *
 * Features:
 * - "Ask NikeAI" in search results for entry
 * - MFE handles all styling, positioning, and animations internally
 * - Mobile: Complete panel hiding when closed
 */
const NikeAIVariantB = () => {
  useEffect(() => {
    initializeNikeAI();
  }, []);

  return <NikeAIPanelWrapper />;
};

NikeAIVariantB.displayName = 'NikeAIVariantB';

export default NikeAIVariantB;
